import axios from "axios";

const API_URL = "vue-auth-frontendapi/auth"; 

export const register = async (name, email, password) => {
  try {
    const res = await axios.post(`${API_URL}/register`, { name, email, password });
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const login = async (email, password) => {
  try {
    const res = await axios.post(`${API_URL}/login`, { email, password });
    localStorage.setItem("token", res.data.accessToken); // JWT store
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};

export const getProfile = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token found");

  try {
    const res = await axios.get(`${API_URL}/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
};
